import { render, staticRenderFns } from "./NewsCategoryModalForm.vue?vue&type=template&id=c285b4c2"
import script from "./NewsCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./NewsCategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports